module.exports = __webpack_public_path__ + "static/media/svgFond.1ba8fe72.svg";